<jb-icon
  *ngIf="iconData"
  class="ml1"
  [name]="iconData.iconName"
  [label]="iconData.label"
  [width]="iconData.width"
  [height]="iconData.height"
>
</jb-icon>
